import { BaseModule } from './base.module';

export class HighContrastModule extends BaseModule {
    mouseTargets = 'h1, h2, h3, h4, h5, h6, p, blockquote, a, button, svg, span';
    inputTargets = 'input, select, textarea, a, button:not(disabled)';
    enabled = false;

    initialize() {
        this.handleActivation();

    }

    handleActivation() {
        this.enabled = true;
        // this.setup();
        // document.documentElement.querySelector('body').classList.add('accessibility-border');
    }

    handleDeactivation() {
        this.enabled = false;
        let borderedElements = document.documentElement.querySelectorAll('.accessibility-border');
        console.log('borderedElements', borderedElements);
        if (borderedElements) {
            borderedElements.forEach((element) => {
                element.classList.remove('accessibility-border');
            });
        }
    }

    setup() {
        // this.setupEventListeners();
    }

    handleElementFocus(event) {
        console.log('focus!', event)
        if (this.enabled == true) {
            if (event && typeof event.target !== 'undefined') {
                // event.target.classList.add('accessibility-border');
            }
        }
    }

    handleElementBlur(event) {
        if (this.enabled == true) {
            if (event && typeof event.target !== 'undefined') {
                event.target.classList.remove('accessibility-border');
                this.speechSynthesis.cancel();
            }
        }
    }

    setupEventListeners() {
        // focusable targets, that will actually do something when they receive focus (inputs)
        document.querySelectorAll(this.inputTargets).forEach((element) => {
            element.addEventListener('focus', (event) => {
                // console.log('focus', event);
                this.handleElementFocus(event);
            });
        });
        document.querySelectorAll(this.inputTargets).forEach((element) => {
            element.addEventListener('blur', (event) => {
                // console.log('focus', event);
                this.handleElementBlur(event);
            });
        });

        // mouseover targets that can not be focused
        document.querySelectorAll(this.mouseTargets).forEach((element) => {
            element.addEventListener('mouseover', (event) => {
                // console.log('focus', event);
                this.handleElementFocus(event);
            });
        });
        document.querySelectorAll(this.mouseTargets).forEach((element) => {
            element.addEventListener('mouseout', (event) => {
                // console.log('focus', event);
                this.handleElementBlur(event);
            });
        });
    }
}
